import { render } from "./docsView.vue?vue&type=template&id=d5235d84"
import script from "./docsView.vue?vue&type=script&lang=js"
export * from "./docsView.vue?vue&type=script&lang=js"

import "./docsView.vue?vue&type=style&index=0&id=d5235d84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__